export const STANDALONE_MODULE_POPUPS = [
    'BulkUpdate',
    'SmartEdit',
    'CellSummary',
];
/**
 * This constants determines the order and the items that appear in the navigation.
 */
export const DEFAULT_SETTINGS_PANEL_NAVIGATION_ITEMS = [
    'GridInfo',
    'ColumnInfo',
    'Dashboard',
    'ToolPanel',
    'StatusBar',
    '-',
    'Layout',
    'CalculatedColumn',
    'FreeTextColumn',
    'CustomSort',
    'Alert',
    'SystemStatus',
    '-',
    'Export',
    'DataImport',
    '-',
    'FormatColumn',
    'StyledColumn',
    'FlashingCell',
    'Theme',
    '-',
    'QuickSearch',
    'GridFilter',
    'ColumnFilter',
    'DataSet',
    'NamedQuery',
    '-',
    'PlusMinus',
    'Shortcut',
    'DataChangeHistory',
    '-',
    'Charting',
    'Schedule',
    'TeamSharing',
    'Note',
    'Comment',
    'StateManagement',
];
